"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var paymentSourceEnum = Object.freeze({
  CARD: "online_cc",
  APPLEPAY: "online_ap",
  GOOGLEPAY: "online_gp"
});
var _default = exports["default"] = paymentSourceEnum;